import { MessageCircle } from "lucide-react";
import { contactInfo } from "@/data/machines";

export default function FloatingWhatsApp() {
  const link = `https://wa.me/${contactInfo.whatsapp}?text=${encodeURIComponent(
    "Hola, quiero información sobre alquiler de maquinaria."
  )}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="WhatsApp"
      className="group fixed bottom-5 right-5 md:bottom-6 md:right-6 z-50 bg-[#25D366] hover:bg-[#1faa55] text-white rounded-full p-4 shadow-2xl shadow-emerald-500/40 hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle className="w-6 h-6 transition-transform duration-300 group-hover:rotate-[8deg]" />
      <span aria-hidden className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping -z-10" />
      <span aria-hidden className="absolute inset-0 rounded-full ring-2 ring-white/30 -z-10" />
    </a>
  );
}
